export function httpsUrl(value) {
  if (typeof value !== 'string') return null
  try {
    const url = new URL(value)
    if (url.protocol !== 'https:' || url.username || url.password) return null
    return url.href
  } catch (error) {
    return null
  }
}

export function bannerForStatus(status) {
  if (status?.linked === true) {
    const href = httpsUrl(status.helply_url)
    return href
      ? {
          heading: 'Moving to Helply',
          text: `${status.linked_by_name ||
            'Someone on your team'} started moving this account to Helply. Groove keeps working as usual until the switch.`,
          action: 'Open Helply',
          href,
        }
      : null
  }
  if (status?.can_start === true) {
    const href = httpsUrl(status.start_url)
    return href
      ? {
          heading: 'Try Helply',
          text:
            'Open Helply and link it to your Groove account. Your conversations and mailboxes will stay in Groove.',
          action: 'Continue to Helply',
          href,
        }
      : null
  }
  return null
}
